export default __webpack_public_path__ + "85f26e2ff1c53e629b9bb1cb2703443e.png";